import styled from 'styled-components';

export const StyledMessageDrawer = styled.div`
    opacity: 0;
    visibility: hidden;
    width: 330px;
    transform: translateX(330px);
    padding: 10px 10px 0;
    transition: all 250ms ease;
    margin-left: -330px;
    display: flex;
    height: 100%;
    min-height: 0;
    min-width: 0;
    flex-direction: column;
    &.active{
        opacity: 1;
        visibility: visible;
        margin-left: 0;
        transform: translateX(0);
    }
    .message-drawer-content{
        display: flex;
        flex: 1;
        min-height: 0;
        min-width: 0;
        flex-direction: column;
        &-overflow{
            display: flex;
            flex: 1;
            overflow: auto;
            min-height: 0;
            min-width: 0;
            flex-direction: column;
            margin-right: -20px;
            padding-right: 20px;
            padding-bottom: 20px;
            position: relative
        }
    }
    .message-drawer-title{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .icon{
            display: flex;
            flex-direction: row;
            align-items: center;
            .btn{
                &:first-child{
                    margin-right: 10px;
                }
            }
            .separator{
                background-color: #DDD;
                width: 2px;
                height: 20px;
                -webkit-transform: rotate(20deg);
                -ms-transform: rotate(20deg);
                transform: rotate(20deg);
                display: block;
                margin-right: 5px;
                margin-left: 5px;
            }
        }
        .text{
            flex: 1;
        }
    }
`;
